import { useSettingsStore, useChatStore, ChatMessage, useAppStore } from '@stores';
import { useEffect, useState, useMemo } from 'react';
import { Glitch } from '@components/helpers/Glitch';
import { useTranslation } from 'react-i18next';
import { Chat } from '@components/chat/Chat';
import { IconX } from '@tabler/icons-react';

export function MiniChat() {
  const [showChat, setShowChat] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  const { t } = useTranslation(undefined, { keyPrefix: 'Chat' });
  const { lobbyMessages, messages, channels } = useChatStore();
  const { hideIngameChat } = useSettingsStore();
  const { userData } = useAppStore();

  const getColor = (message: ChatMessage) => {
    const channel = channels.find(c => c.id === message.channelId);
    if (channel?.type === 'DIRECT') return 'text-purple-400';
    if (!message.channelId) return 'text-blue-400';
    return '';
  };

  const lastMessages = useMemo(() => {
    const combined = [...lobbyMessages, ...messages];

    return combined
      .filter(m => !m.type || m.type !== 'LEFT_CHAT')
      .filter(m => !userData.blocked.includes(m.author?.id ?? ''))
      .sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())
      .slice(-2);
  }, [lobbyMessages, messages]);

  useEffect(() => {
    setFadeOut(false);

    const timeout = setTimeout(() => {
      setFadeOut(true);
    }, 5000);

    return () => clearTimeout(timeout);
  }, [lastMessages]);

  const shorten = (content: string) => content.length > 96
    ? content.substring(0, 96) + '...'
    : content;

  if (hideIngameChat) return null;

  return (
    <>
      <div className={`${showChat ? 'flex' : 'hidden'} chat-modal`}>
        <div className="chat-modal-header">
          <p className="pl-2 text-lg active"><Glitch>Chat</Glitch></p>
          <button onClick={() => setShowChat(false)} className="chat-modal-close">
            <IconX size={20} />
          </button>
        </div>

        <Chat />
      </div>

      <div className={`${fadeOut && 'opacity-0'} mini-chat`}>
        {lastMessages.map((message) => (
          <p
            className="text-xs opacity-50 pointer-events-auto inline-block"
            onClick={() => setShowChat(true)}
            key={message.createdAt}
          >
            <span className={getColor(message)}>{message.author?.username ?? t('system')}</span>
            <span>: {shorten(message.content)}</span>
          </p>
        ))}
      </div>
    </>
  );
}